/**
 * @author Kelnik
 *
 * TariffsProgram - программа доходности
 */

import 'jquery-match-height';
import {Utils} from 'common/scripts/utils';

class TariffsProgram {
    constructor(options) {
        this.container = options.container;
        this.itemSelector = '.j-tariffs-program-item';
        this.toggleSelector = '.j-tariffs-program-toggle';
        this.hiddenElSelector = '.j-tariffs-program-hidden';
    }

    init() {
        this._initElements();
        this._initMatchHeight();
        this._bindEvents();
    }

    _initElements() {
        this.toggles = this.container.querySelectorAll(this.toggleSelector);
    }

    _initMatchHeight() {
        $('.tariffs-program__title h5').matchHeight();
        $('.tariffs-program__description').matchHeight();
        $('.tariffs-program__prop-text[data-mh="income"]').matchHeight();
        $('.tariffs-program__prop-text[data-mh="expenses"]').matchHeight();
        $('.tariffs-program__prop-text[data-mh="term"]').matchHeight();
    }

    _bindEvents() {
        this.toggles.forEach((toggle) => {
            toggle.addEventListener('click', this._clickToggle.bind(this, toggle));
        });

        window.addEventListener('resize', Utils.debounce(this._resize.bind(this), 100));
    }

    _resize() {
        if (window.innerWidth < 960) {
            this._updateAllMaxHeight();
        } else {
            this._closeAll();
        }
    }

    _clickToggle(toggle) {
        const parentItem = Utils.closest(toggle, this.itemSelector);
        const hiddenBlock = parentItem ? parentItem.querySelector(this.hiddenElSelector) : null;

        if (!hiddenBlock) {
            return;
        }

        if (parentItem.classList.contains('is-open')) {
            parentItem.classList.remove('is-open');
            hiddenBlock.style.maxHeight = '0';
        } else {
            parentItem.classList.add('is-open');
            hiddenBlock.style.maxHeight = `${hiddenBlock.scrollHeight}px`;
        }
    }

    _updateAllMaxHeight() {
        this.toggles.forEach((toggle) => {
            const parentItem = Utils.closest(toggle, this.itemSelector);
            const hiddenBlock = parentItem ? parentItem.querySelector(this.hiddenElSelector) : null;

            if (parentItem.classList.contains('is-open') && hiddenBlock) {
                hiddenBlock.style.maxHeight = `${hiddenBlock.scrollHeight}px`;
            }
        });
    }

    _closeAll() {
        this.toggles.forEach((toggle) => {
            const parentItem = Utils.closest(toggle, this.itemSelector);
            const hiddenBlock = parentItem ? parentItem.querySelector(this.hiddenElSelector) : null;

            if (!hiddenBlock) {
                return;
            }

            parentItem.classList.remove('is-open');
            hiddenBlock.removeAttribute('style');
        });
    }
}


export default TariffsProgram;
